import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { Provider } from 'react-redux';
import reduxStore from '../reduxStore';

import routes from '../../config/routes';
import { setRouter } from '../lib/browserHistory';

export default function AppRouter() {
  const router = createBrowserRouter(routes as any);

  // Wire the browserHistory shim so imperative navigation (jsUi, etc.) goes
  // through this router.
  setRouter(router);

  const container = document.getElementById('app') as HTMLElement;
  const root = createRoot(container);

  root.render(
    <Provider store={reduxStore}>
      <RouterProvider router={router} />
    </Provider>,
  );
}
